import React, { useEffect, useState } from "react";
import { PrimaryButton, DefaultButton, TextField, Stack, Persona, PersonaPresence, getTheme, Text, Separator, Spinner, FontIcon, Slider, ChoiceGroup, Depths, IconButton, ActionButton, Modal, Panel, PanelType } from "@fluentui/react";
// import your existing PeoplePicker and TagPicker-ish components

import { Chip, ExpandableText } from "./ProposalDashboard.js";
import { styles } from "./ProjectDashboard.js";
import MetaTable from "../components/MetaTable.js";
import axios from "axios";
import { breadcrumbClassNames } from "@fluentui/react-components";

export default function WorkplanBuilder(props) {
  const [personIds, setPersonIds] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState([]);


  // AI responses from server
  const [generatedWorkplan, setGeneratedWorkplan] = useState("");
  const [generatedAbout, setGeneratedAbout] = useState("");
  const [generatedApproach, setGeneratedApproach] = useState("");
  const [generatedTeam, setGeneratedTeam] = useState("");
  const [generatedBudget, setGeneratedBudget] = useState("");
  const [generatedBios, setGeneratedBios] = useState([]);



  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [allTags, setAllTags] = useState([]);
  const [allPeople, setAllPeople] = useState([]);
  const [responseMeta, setResponseMeta] = useState(null);
  const [additionalContext, setAdditionalContext] = useState("");
  const [length, setLength] = useState(250);
  const [perspective, setPerspective] = useState("Third Person");
  const [reviseSection, setReviseSection] = useState({show: false, original : "", instructions: ""});
  const [showPrompt, setShowPropmt] = useState({
    about: false,
    approach: false,
    workplan: false,
    team: false,
    budget: false
  });


  const [sections, setSections] = useState({
    about: false,
    aboutInstructions: "",
    approach: false,
    approachInstructions: "",
    team: false,
    teamInstructions: "",
    workplan: false,
    workplanInstructions: "",
    budget: false,
    budgetInstructions: ""
  });


  const [projectSpecs, setProjectSpecs] = useState({
    title: "",
    clientName: "",
    from: "",
    to: "",
  });

  const [propmtViewer, setPromptViewer] = useState("");

  const canGenerate = selectedTagIds.length > 0;

  async function askForRevision() {
    try {
      axios.post(`/api/proposals/revise-ai`, {original: reviseSection.original, instructions: reviseSection.instructions, section: reviseSection.show})
      .then(res => {
        switch(reviseSection.show){
          case 'about':
            setGeneratedAbout(res.data.revision);
            break;
          case 'approach':
            setGeneratedApproach(res.data.revision);
            break;
          case 'workplan':
            setGeneratedWorkplan(res.data.revision);
            break;
          case 'team':
            setGeneratedTeam(res.data.revision);
            break;
          case 'budget':
            setGeneratedBudget(res.data.revision);
            break;
        }
        setReviseSection(prev => ({...prev, show: '', orginal: '', instructions: ''}));
      })  
    } catch(err) {
      console.error(err);
    }
  }

  async function handleGenerate() {
    setIsLoading(true);
    setError("");
    setGeneratedWorkplan("");
    setGeneratedAbout("");
    setGeneratedApproach("");

    try {
      axios.all(personIds.map(pid => (
        axios.post(`/api/people/generate-bio`, {
          personId: pid,
          tagIds: selectedTagIds,
          proposalId: null,
          context: additionalContext,
          length,
          perspective
        })
      )))
      .then(axios.spread((...people) => {
        setGeneratedBios(people.map(p => p.data));
      }))
      .catch(err => {
        console.log('ERR: ', err)
      })
    } catch (err){
      console.error("Unable to generate bios");
    }


    try {
      const res = await fetch("/api/proposals/generate-workplan", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          personIds,
          tagIds: selectedTagIds,
          context: additionalContext,
          sections,
          length,
          perspective,
          projectSpecs
        }),
      });

      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || "Failed to generate");
      }

      const data = await res.json();
      setGeneratedWorkplan(data.workplan || "");
      setGeneratedAbout(data.about || "");
      setGeneratedApproach(data.approach || "");
      setGeneratedTeam(data.team || "");
      setGeneratedBudget(data.budget || "");
      setResponseMeta(data.meta || null);
    } catch (err) {
      console.error(err);
      setError(err.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  }

  const fetchAllTags = async () => {
    try {
      const res = await fetch(`/api/tags`);
      const data = await res.json();
      setAllTags(data);
      // return data;
    } catch (e) {
      console.error(e);
      // return [];
    }
  }

  const fetchAllPeople = async () => {
    try {
      const res = await fetch(`/api/people`, {params: {active: true}});
      const data = await res.json();
      setAllPeople(data.data.filter(el => el.active));
      // return data;
    } catch (e) {
      console.error(e);
      // return [];
    }
  }

  useEffect(() => {
    fetchAllTags();
    fetchAllPeople();
  }, []);


  console.log({responseMeta});

  return (

    <Stack tokens={{ childrenGap: 16 }} styles={{root: { padding: 24, maxWidth: 1200, margin: '0 auto' }}}>
      <Text variant="xxLarge">
        <FontIcon iconName="ChatBot" style={{marginRight: 8}} />
        Proposal Builder
      </Text>
      <Text>
        This tool was built to help you generate a proposal ready documents by pulling information from previously written proposals. You can provide additional context and instructions to tailor your response to your specific needs. Chat GPT will use the gpt-4.1-mini model to generate a response. After generating, please check the "System" and "User Prompts" for errors. You can adjust your query and regenerate the response as necessary.
      </Text>
      <Separator />

      {/* Sections Selector */}
      <Stack.Item grow={1} className={styles.sectionCard}>
        <Stack tokens={{childrenGap: 8}}>
          <Text variant="xLarge">What sections do you need?</Text>
        </Stack>
        <Separator />
        <Stack horizontal wrap tokens={{childrenGap: 8}}>
          <Chip size={16} style={{padding: '4px 12px'}}primary={sections.about} onClick={() => setSections(prev => ({...prev, about: !prev.about}))}>About</Chip>
          <Chip size={16} style={{padding: '4px 12px'}}primary={sections.approach} onClick={() => setSections(prev => ({...prev, approach: !prev.approach}))}>Approach</Chip>
          <Chip size={16} style={{padding: '4px 12px'}}primary={sections.workplan} onClick={() => setSections(prev => ({...prev, workplan: !prev.workplan}))}>Workplan</Chip>
          <Chip size={16} style={{padding: '4px 12px'}}primary={sections.team} onClick={() => setSections(prev => ({...prev, team: !prev.team}))}>Team</Chip>
          <Chip size={16} style={{padding: '4px 12px'}}primary={sections.budget} onClick={() => setSections(prev => ({...prev, budget: !prev.budget}))}>Budget</Chip>
        </Stack>
      </Stack.Item>

      {/* Tag selector */}
      <Stack.Item grow={1} className={styles.sectionCard}>
        <Stack tokens={{childrenGap: 8}}>
          <Text variant="xLarge">What should the proposal focus on?</Text>
          <Text>
            The Ai builder will search our database for any past proposals with the selected tags before Ai generates a new proposal sections.
          </Text>
        </Stack>
        <Separator />
        <Stack horizontal wrap tokens={{childrenGap: 8}}>
          {
            allTags.map(tag => {
              return <Chip key={tag.id} style={{padding: '4px 12px'}} size={16} primary={selectedTagIds.includes(tag.id)} onClick={() => setSelectedTagIds(prev => prev.includes(tag.id) ? prev.filter(el => el !== tag.id) : prev.concat(tag.id))}>{tag.name}</Chip>
            })
          }
        </Stack>
      </Stack.Item>

      {/* Person selector */}
      <Stack.Item hidden={!sections.team} grow={1} className={styles.sectionCard}>
        <Stack tokens={{childrenGap: 8}}>
          <Text variant="xLarge">Who is this for?</Text>
          <Text>
            The Ai builder will search write a section describing the selected team members and roles, as well as individual bios. These will be tailored to match the specific areas of practice identified.
          </Text>
        </Stack>
        <Separator />
        <Stack horizontal wrap tokens={{childrenGap: 8}}>
          {
            allPeople.map(person => {
              let includes = personIds.includes(person.id);
              return <Stack.Item key={person.id}>
                <Persona 
                  styles={{
                    root: {
                      cursor: 'pointer', 
                      background: includes ? `${getTheme().palette.green}30` : 'none',
                      border: `1px solid ${includes ? getTheme().palette.green : getTheme().palette.neutralLight}`,
                      padding: 4,
                      height: 'auto',
                      borderRadius: 48,
                      selectors: {
                        '&:hover': {
                          boxShadow: Depths.depth8,
                          transform: 'translateY(-2px)',
                        },
                      },
                    },
                    primaryText: {
                      userSelect: 'none'
                    }
                  }} 
                  onClick={() => setPersonIds(prev => includes ? prev.filter(el => el !== person.id) : prev.concat(person.id))}
                  imageUrl={person.image_url} 
                  presence={includes ? PersonaPresence.online : PersonaPresence.none} text={person.name} />
              </Stack.Item>
            })
          }
        </Stack>
      </Stack.Item>

      {/* More Context / Settings */}
      <Stack horizontal tokens={{childrenGap: 16}}>
        <Stack.Item grow={1} className={styles.sectionCard}>
          <Text variant="xLarge">General instructions</Text>
          <Separator />
          <TextField
            value={additionalContext} 
            placeholder="Add additional context here. Or leave blank." 
            onChange={(e, v) => setAdditionalContext(v)} 
            multiline 
            rows={4} />
          
          <Text variant="xLarge">Section specific instructions</Text>
          <Separator />
          <Stack tokens={{childrenGap: 8}}>
            {sections.about && <TextField
              label="About"
              placeholder="Add additional context here. Or leave blank."
              onChange={(e, val) => setSections(prev => ({...prev, aboutInstructions: val}))}
              multiline
              rows={4}
              value={sections.aboutInstructions} />}

            {sections.approach && <TextField
              label="Approach"
              placeholder="Add additional context here. Or leave blank."
              onChange={(e, val) => setSections(prev => ({...prev, approachInstructions: val}))}
              multiline
              rows={4}
              value={sections.approachInstructions} />}

            {sections.workplan && <TextField
              label="Workplan"
              placeholder="Add additional context here. Or leave blank."
              onChange={(e, val) => setSections(prev => ({...prev, workplanInstructions: val}))}
              multiline
              rows={4}
              value={sections.workplanInstructions} />}
            
            {sections.team && <TextField
              label="Team"
              placeholder="Add additional context here. Or leave blank."
              onChange={(e, val) => setSections(prev => ({...prev, teamInstructions: val}))}
              multiline
              rows={4}
              value={sections.teamInstructions} />}
            
            {sections.budget && <TextField
              label="Budget"
              placeholder="Add additional context here. Or leave blank."
              onChange={(e, val) => setSections(prev => ({...prev, budgetInstructions: val}))}
              multiline
              rows={4}
              value={sections.budgetInstructions} />}
            
          </Stack>
          
        </Stack.Item>
        <Stack.Item grow={1} className={styles.sectionCard}>
          <Text variant="xLarge">Project details</Text>
          <Separator />
          <MetaTable 
            borderless 
            labelColWidth={120}
            items={[
              {
                label: "Title",
                text: "title",
                onRender: () => <TextField  name="Project Title" onChange={(_, title) => setProjectSpecs(prev => ({...prev, title}))} />
              },
              {
                label: "Prepared For",
                text: "client",
                onRender: () => <TextField name="Prapared For" onChange={(_, clientName) => setProjectSpecs(prev => ({...prev, clientName}))} />
              },
              {
                label: "From",
                text: "from",
                onRender: () => <TextField name="From" placeholder="yyyy-mm-dd" onChange={(_, from) => setProjectSpecs(prev => ({...prev, from}))} />
              },
              {
                label: "To",
                text: "to",
                onRender: () => <TextField name="To" placeholder="yyyy-mm-dd" onChange={(_, to) => setProjectSpecs(prev => ({...prev, to}))} />
              },
              
            ]}></MetaTable>
        </Stack.Item>
      </Stack>

      <Stack horizontal tokens={{ childrenGap: 8 }} horizontalAlign="center">
        <PrimaryButton
          iconProps={{iconName: "Robot"}}
          styles={{root: {height: 42, fontSize: 18}, icon: {fontSize: 24}}}
          text={isLoading ? "Generating..." : "Generate Proposal"}
          onClick={handleGenerate}
          disabled={!canGenerate || isLoading}
        />
      </Stack>

      {error && <div style={{ color: "salmon" }}>{error}</div>}

      {
        propmtViewer && <Panel isOpen={propmtViewer} type={PanelType.medium} onDismiss={() => setPromptViewer(null)}>
          <Text variant="xLarge">{propmtViewer.title}</Text>
          <Separator />
          {propmtViewer.text}
        </Panel>
      }


      {
        generatedAbout && <Stack horizontal tokens={{childrenGap: 8}}>
          <Stack.Item grow={1} className={styles.sectionCard}>
            <Stack horizontal horizontalAlign="space-between">
              <Text variant="xLarge">
                Generated About Section
              </Text>
            </Stack>
            <Separator />
            <TextField
              multiline
              rows={10}
              value={generatedAbout}
              autoAdjustHeight
              onChange={(_, v) => setGeneratedAbout(v || "")}
              placeholder="The generated about section will show up here."
            />
            {
              reviseSection.show === 'about' && <TextField label="Instructions" description="Provide additional instructions to revise this section" value={reviseSection.instructions} onChange={(e, v) => setReviseSection(prev => ({...prev, instructions: v}))} />
            }
            <div style={{marginTop: 16, display: 'flex', gap: 8}}>
              <DefaultButton 
                text={reviseSection.show === 'about' ? "Submit" : "Revise Text"}
                iconProps={{iconName: "Refresh"}}
                primary={reviseSection.show === 'about'}
                styles={{root: {borderRadius: '16px'}}}
                onClick={() => reviseSection.show === 'about' ? askForRevision() : setReviseSection({show: 'about', original: generatedAbout, instructions: ""})} />
              <DefaultButton
                text={"Show Prompt"} 
                styles={{root: {borderRadius: '16px'}}}
                onClick={() => setPromptViewer({title: "About Section Prompt", text: responseMeta?.userAboutPrompt})}
                iconProps={{iconName: "StatusCircleQuestionMark"}} />
            </div>
          </Stack.Item>
        </Stack>
      }


      {
        generatedApproach && <Stack horizontal tokens={{childrenGap: 8}}>
          <Stack.Item grow={1} className={styles.sectionCard}>
            <Text variant="xLarge">Generated Approach Section</Text>
            <Separator />
            <TextField
              multiline
              rows={10}
              value={generatedApproach}
              autoAdjustHeight
              onChange={(_, v) => setGeneratedApproach(v || "")}
              placeholder="The generated approach section will show up here."
            />

            {
              reviseSection.show === 'approach' && <TextField label="Instructions" description="Provide additional instructions to revise this section" value={reviseSection.instructions} onChange={(e, v) => setReviseSection(prev => ({...prev, instructions: v}))} />
            }
            <div style={{marginTop: 16, display: 'flex', gap: 8}}>
              <DefaultButton 
                text={reviseSection.show === 'approach' ? "Submit" : "Revise Text"}
                iconProps={{iconName: "Refresh"}}
                primary={reviseSection.show === 'approach'}
                styles={{root: {borderRadius: '16px'}}}
                onClick={() => reviseSection.show === 'approach' ? askForRevision() : setReviseSection({show: 'approach', original: generatedApproach, instructions: ""})} />
              <DefaultButton
                text={"Show Prompt"} 
                styles={{root: {borderRadius: '16px'}}}
                onClick={() => setPromptViewer({title: "Approach Section Prompt", text: responseMeta?.userApproachPrompt})}
                iconProps={{iconName: "StatusCircleQuestionMark"}} />
            </div>
          </Stack.Item>
        </Stack>
      }


      {
        generatedWorkplan && <Stack horizontal tokens={{childrenGap: 8}}>
          <Stack.Item grow={1} className={styles.sectionCard}>
            <Text variant="xLarge">Generated Workplan Section</Text>
            <Separator />
            <TextField
              multiline
              rows={10}
              value={generatedWorkplan}
              autoAdjustHeight
              onChange={(_, v) => setGeneratedWorkplan(v || "")}
              placeholder="The generated workplan section will show up here."
            />
            {
              reviseSection.show === 'workplan' && <TextField label="Instructions" description="Provide additional instructions to revise this section" value={reviseSection.instructions} onChange={(e, v) => setReviseSection(prev => ({...prev, instructions: v}))} />
            }
            <div style={{marginTop: 16, display: 'flex', gap: 8}}>
              <DefaultButton 
                text={reviseSection.show === 'workplan' ? "Submit" : "Revise Text"}
                iconProps={{iconName: "Refresh"}}
                primary={reviseSection.show === 'workplan'}
                styles={{root: {borderRadius: '16px'}}}
                onClick={() => reviseSection.show === 'workplan' ? askForRevision() : setReviseSection({show: 'workplan', original: generatedWorkplan, instructions: ""})} />
              <DefaultButton
                text={"Show Prompt"} 
                styles={{root: {borderRadius: '16px'}}}
                onClick={() => setPromptViewer({title: "Workplan Section Prompt", text: responseMeta?.userWorkplanPrompt})}
                iconProps={{iconName: "StatusCircleQuestionMark"}} />
            </div>
          </Stack.Item>
        </Stack>
      }

      {
        generatedTeam && <Stack horizontal tokens={{childrenGap: 8}}>
          <Stack.Item grow={1} tokens={{childrenGap: 16}} className={styles.sectionCard}>
            <Text variant="xLarge">Generated Team Section</Text>
            <Separator />
            <TextField
              multiline
              rows={10}
              value={generatedTeam}
              autoAdjustHeight
              borderless
              onChange={(_, v) => setGeneratedTeam(v || "")}
              placeholder="The generated team section will show up here."
            />
            {
              generatedBios && generatedBios.length > 0 && generatedBios.map(person => {
                return <div key={person.meta.person.id}>
                  <Stack tokens={{childrenGap: 8}}>
                    <Stack.Item tokens={{childrenGap: 8}}>
                      <Text variant="large">{person.meta.person.name} </Text>
                      <Text>{person.meta.person.designation}</Text>
                    </Stack.Item>
                    <TextField
                      multiline
                      rows={10}
                      value={person.bio}
                      autoAdjustHeight
                      borderless
                      // onChange={(_, v) => setGeneratedTeam(v || "")}
                      placeholder="The generated bio will show up here."
                    />
                  </Stack>
                </div>
              })
            }
          </Stack.Item>
          <Stack.Item hidden={!showPrompt.team} grow={1} className={styles.sectionCard}>
            <Text variant="xLarge">Team Section Prompt</Text>
            <Separator />
            <TextField 
              readOnly 
              multiline 
              autoAdjustHeight 
              rows={10} 
              value={responseMeta?.userTeamPrompt} />
          </Stack.Item>
        </Stack>
      }

      {
        generatedBudget && <Stack horizontal tokens={{childrenGap: 8}}>
          <Stack.Item grow={1} className={styles.sectionCard}>
            <Text variant="xLarge">Generated Budget Section</Text>
            <Separator />
            <TextField
              multiline
              rows={10}
              value={generatedBudget}
              autoAdjustHeight
              onChange={(_, v) => setGeneratedBudget(v || "")}
              placeholder="The generated budget section will show up here."
            />
          </Stack.Item>
          <Stack.Item hidden={!showPrompt.budget} grow={1} className={styles.sectionCard}>
            <Text variant="xLarge">Budget Section Prompt</Text>
            <Separator />
            <TextField 
              readOnly 
              multiline 
              autoAdjustHeight 
              rows={10} 
              value={responseMeta?.userBudgetPrompt} />
          </Stack.Item>
        </Stack>
      }
      

      {
        responseMeta && (
          <Stack horizontal tokens={{childrenGap: 12}}>
            <Stack.Item grow={1} className={styles.sectionCard} >
              <Text variant="xLarge">System Prompt</Text>
              <Separator />
              <ExpandableText text={responseMeta.systemPrompt || "Not available"} />
            </Stack.Item>
          </Stack>
        )
      }
    </Stack>
  );
}
